const faqData = [
  {
    question: "What is LeetEngineer?",
    answer: "LeetEngineer is an AI-powered platform designed to help engineering candidates prepare for job interviews and build professional resumes. We generate role-specific interview questions, detailed answer guides, and create tailored resumes based on job postings."
  },
  {
    question: "How does LeetEngineer work?",
    answer: "Simply paste an engineering job post into our platform, and our AI will instantly generate tailored technical questions, HR screening prep, and custom resumes specific to that engineering role and company."
  },
  {
    question: "Can LeetEngineer help me build resumes?",
    answer: "Yes! You can create professional resumes from scratch or perfectly tailored to specific job postings. Our AI analyzes your experience and optimizes content to highlight your engineering expertise for ATS systems and hiring managers."
  },
  {
    question: "Is LeetEngineer suitable for all engineering fields?",
    answer: "No! Our AI adapts to various engineering disciplines such as mechanical, aeronautical, civil, electrical, chemical, biomedical, and engineering roles that undergo technical scenario based interviews. Just provide the job posting for personalized content."
  },
  {
    question: "How accurate are the generated questions, answers, and resumes?",
    answer: "Our AI is trained on thousands of real engineering interview experiences, job postings, and resume data, ensuring high-quality, relevant content that matches actual interview patterns and resume standards from top engineering companies."
  },
  {
    question: "Is my data secure when using LeetEngineer?",
    answer: "Yes, we use industry-standard security measures including encryption and secure data handling. We never share your personal information, job application details, or resume data with third parties."
  },
  {
    question: "Do you offer refunds?",
    answer: "We offer refunds within 30 days of purchase for eligible accounts. If you're not satisfied with our service, please contact our support team at support@leetengineerai.com with your account details and reason for the refund request. We'll review your case and process the refund promptly."
  }
];

export default faqData;
